export function formatPhone(phone: string) {
  if (phone && phone.trim() !== "") {
    const digits = phone.replace(/\D/g, "");

    if (digits.length >= 11) {
      return `${digits.substring(0, digits.length - 10)} (${digits.substring(
        digits.length - 10,
        digits.length - 7,
      )}) ${digits.substring(digits.length - 7, digits.length - 4)}-${digits.substring(
        digits.length - 4,
        digits.length,
      )}`;
    } else if (digits.length === 10) {
      return `1 (${digits.substring(0, digits.length - 7)}) ${digits.substring(
        digits.length - 7,
        digits.length - 4,
      )}-${digits.substring(digits.length - 4, digits.length)}`;
    } else if (digits.length >= 5) {
      return `${digits.substring(digits.length - 7, digits.length - 4)}-${digits.substring(
        digits.length - 4,
        digits.length,
      )}`;
    }

    return phone;
  }

  return "";
}
